var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.957H16.75V14.457C16.75 13.2144 15.7426 12.207 14.5 12.207C13.7833 12.207 13.1449 12.5421 12.7328 13.0642M13 15.957H5.5M13 15.957V14.457C13 13.9649 12.9052 13.4948 12.7328 13.0642M5.5 15.957H1.75V14.457C1.75 13.2144 2.75736 12.207 4 12.207C4.71671 12.207 5.35514 12.5421 5.76718 13.0642M5.5 15.957V14.457C5.5 13.9649 5.59482 13.4948 5.76718 13.0642M5.76718 13.0642C6.32013 11.6828 7.67111 10.707 9.25 10.707C10.8289 10.707 12.1799 11.6828 12.7328 13.0642M11.5 6.20703C11.5 7.44967 10.4926 8.45703 9.25 8.45703C8.00736 8.45703 7 7.44967 7 6.20703C7 4.96439 8.00736 3.95703 9.25 3.95703C10.4926 3.95703 11.5 4.96439 11.5 6.20703ZM16 8.45703C16 9.28546 15.3284 9.95703 14.5 9.95703C13.6716 9.95703 13 9.28546 13 8.45703C13 7.6286 13.6716 6.95703 14.5 6.95703C15.3284 6.95703 16 7.6286 16 8.45703ZM5.5 8.45703C5.5 9.28546 4.82843 9.95703 4 9.95703C3.17157 9.95703 2.5 9.28546 2.5 8.45703C2.5 7.6286 3.17157 6.95703 4 6.95703C4.82843 6.95703 5.5 7.6286 5.5 8.45703Z",
    stroke: "#3485AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.2389d98abbfd9f346d49ddb726b89df6.svg";
export { ForwardRef as ReactComponent };